module.exports = {
    message:{
        helpCenter:"Help center",
        wallet:"Wallets",
        account:"Account",
        csaf:"Bonus Points",
        backupAndRestore:"Backup and Recovery",
        committee:"Committee",
        witness:"Witness",
        authorizedRegistrars:"Authorized Registrars",
        vote:"Voting",
        collateral:"Collateral",
        gateway:"ERC20 Gateway",
        extraFunctions:"Extra functions",

        wallet_info:[
            {
                title:"About YOYOW Wallet",
                desc:[
                    "YOYOW is a media public chain based on blockchain technology. The wallet is a web-based application, which is operated in a browser and connected through a trusted node. You can conveniently manage your YOYO assets here."
                ]
            },
            {
                title:"Wallet Security",
                desc:[
                    "Please make sure to back up your private key (only appears once upon successful registration). The browser will not store your private Owner Key. Other private keys from lower authority levels will be encrypted using your wallet password and stored in the browser’s local database."
                ]
            },
            {
                title:"Account Recovery",
                desc:[
                    "Your account can be rebuilt using the private Owner Key while certain circumstances (such as switching computer, computer failure or browser crash) lead to the loss of local data on your browser."
                ]
            },
            {
                title:"Balance",
                desc:[
                    "①The balance can be seen as your account’s primary wallet. To transfer balances and pay fees, you will need to have active authority over the funds.",
                    "②The YOYO in the balance can accumulate Bonus Points.",
                    "③We recommend storing most of your YOYO in the balance."
                ]
            },
            {
                title:"Liquid Assets",
                desc:[
                    "①Liquid assets can be seen as your account’s auxiliary wallet for small amounts of savings and transfers, requiring the secondary authority level.",
                    "②YOYO in liquid assets cannot accumulate Bonus Points.",
                    "③As third-party platform may acquire secondary authority, we recommend only keeping a small amount of YOYO in liquid assets."
                ]
            },
        ],

        account_info:[
            {
                title:"Account",
                desc:[
                    "You will need to sign up for a YOYOW account to access the system. Set an account password, the system will automatically assign you a YOYOW account. The basic information of each account includes: digital UID (YOYO No.) and account name (nickname)."
                ]
            },
            {
                title:"Account Registration",
                desc:[
                    "①Only authorized registrars are eligible to register a new account",
                    "②The list of Authorized Registrars will be specified by the committee"
                ]
            },
            {
                title:"Account Authorization",
                desc:[
                    "①There are three levels of account authorization: owner, active and secondary",
                    "②Owner: for modifying of other authorizations",
                    "③Active: able to modify secondary authorizations; able to transfer balances",
                    "④Secondary: for various actions on media platforms (to post, reply to posts and like posts); able to transfer liquid assets",
                    "⑤Authorization at each level is for actions within that level only. No action beyond or below one’s authorization is allowed.",
                ]
            }
        ],

        csaf_info:[
            {
                title:"Bonus Points",
                desc:[
                    "Bonus Points are rewards for YOYO holders. When your account holds YOYO, Bonus Points will be accumulated over time. There is an upper limit for Bonus Points accumulated, and you have to withdraw Bonus Points manually."
                ]
            },
            {
                title:"Using Bonus Points",
                desc:[
                    "At present, the only use of Bonus Points is for paying fees. You can use Bonus Points to offset fees. 100 Bonus Points can be used as 1 YOYO,under the circumstances."
                ]
            },
            {
                title:"Acquisition of Bonus Points",
                desc:[
                    "①When the “balance” of your account reaches a certain amount of YOYO, the system will automatically accumulate Bonus Points for you.Highest amount of accumulation = Rate of Credit Accumulation * 7",
                    "②Rate of Credit Accumulation: the current setting allows you to withdraw Bonus Points equivalent to 1 YOYO per day for every 10,000 YOYO.",
                    "③Bonus Points are withdrawn manually. You can manually withdraw available Bonus Points to your account."
                ]
            },
            {
                title:"Credit Rental",
                desc:[
                    "A credit rental function will be enabled in the future."
                ]
            },
            {
                title:"Gifting Bonus Points",
                desc:[
                    "Currently, when implementing the “withdrawing Bonus Points” action, you are able to select the account of a contact and withdraw the Bonus Points into their account."
                ]
            },
        ],

        backupAndRestore_info:[
            {
                title:"Private Key Backup",
                desc:[
                    "After successful registration, the system will return to you a private key for your account. The private key is for the owner authorization within your account authorization.",
                    "The private key will appear only ONCE. The system will not store it for you, neither will it be stored in your browser. Therefore, you must manually back it up."
                ]
            },
            {
                title:"Recovering an Account with a Private Key",
                desc:[
                    "The principle of this method is: to use the owner authorization private key to generate a key pair for other authorization levels",
                    "This method will require you to enter a new wallet password for the encryption of new key pairs",
                    "Necessary parameters: owner authorization private key for the account and new account password",
                    "This action requires broadcasting to the blockchain and a fee will be charged"
                ]
            },
        ],

        committee_info:[
            {
                title:"Committee",
                desc:[
                    "A group of committee members voted in by the shareholders are responsible for setting parameters of the system operation."
                ]
            },
            {
                title:"The Responsibilities of committee",
                desc:[
                    "Adjusting the various system operation parameters, including fees and block production rewards",
                    "In contrast to the BitShares, the YOYOW committee is more like an executive institution, with partial decision-making authority"
                ]
            },
            {
                title:"The committee Setup",
                desc:[
                    "The number of committee members is initially fixed at five, and cannot be modified.",
                    "The tenure of committee members is set at one month, and cannot be modified.",
                    "The committee members on the initial list will be appointed by the system, with subsequent committee members decided by votes taken by token holders.",
                    "A compensation mechanism has not yet been established."
                ]
            },
            {
                title:"Candidates for the committee",
                desc:[
                    "Any account with collateral over a certain amount of YOYO can become a candidate for the committee. The initial figure is set at 1,000 YOYO.",
                    "Only candidates for the committee are qualified to become formal committee members."
                ]
            },
            {
                title:"Committee Elections",
                desc:[
                    "Each token holder has one vote that can be used for one candidate—that is to say, an account can only support one candidate at a time, and the voter can change their vote at any time.",
                    "Other rules such as voting qualification, voting intention, total valid votes, validity period for voting, and proxies are used in conjunction with witness voting. Please refer to “Token Holder Voting” in [witness] (witness.md) design for information.",
                    "The five candidates with the most votes at re-election time will become the new incumbent committee members. Currently, there is no regulation on minimum votes."
                ]
            },
            {
                title:"Committee Proposals",
                desc:[
                    "Incumbent committee members may initiate proposals to be voted on by all committee members.",
                    "Each proposal includes the following attributes: proposal content, voting deadline, threshold for voting approval and the date from which it would take effect.",
                    "The threshold for approval will be set in advance according to the type of proposal, and cannot be assigned. Only a threshold for approval has been set for the time being, with no threshold for disapproval.",
                    "A proposal may contain more than one item of content, in which case approval or disapproval of all items is required, and the highest threshold for approval among the various contents will be recognized as the threshold for approval.",
                    "The date from which a proposal would take effect must not be later than the end date of the tenure. The date of effect can be backdated, resulting in it “taking immediate effect.”",
                    "committee votes can have three statuses—approve, abstain and disapprove. It is assumed that the initiator of the proposal has voted to approve it. Each committee member shall have one vote, which can be changed before it comes into effect.",
                    "Under the condition that the number of affirmative votes has reached the threshold, if the date of effect is in the past, the proposal will come into effect immediately. Otherwise, the proposal will come into force on the planned date of effect.",
                    "Before the close of voting, and before the proposal’s date of effect, a voter is allowed to change their vote. However, after the close of voting, no change will be accepted.",
                    "committee proposals shall be voted on within the tenure. Proposals whose voting has not finished within that time period will be automatically canceled upon the termination of the tenure. Approved proposals will come into effect as planned and the validity of such proposals will not be impacted by the tenure ending.",
                    "Since different preset system parameters have different enabling conditions/methods, a proposals’ entry into force does not mean system parameters will be modified immediately."
                ]
            },
            {
                title:"Resignation of committee Members",
                desc:[
                    "Candidates for committee/formal committee members can terminate their capacity as committee members and the system will return their deposit.",
                    "After a formal committee member resigns, their capacity within that tenure will not be impacted, but in the next tenure that committee member will lose all voting rights.",
                    "After resignation, all votes will undergo zero clearing (coming into effect after the re-elections)",
                    "If an application to become a committee member is filed during the delayed release period, the tokens not released will be locked again. However, cleared votes cannot be recovered."
                ]
            },
        ],
        witness_info:[
            {
                title:"Witness",
                desc:[
                    "Voted by shareholders, witnesses are responsible for block production and maintaining the blockchain, receiving corresponding rewards at the same time."
                ]
            },
            {
                title:"Types of Witness",
                desc:[
                    "Top witnesses: directly voted in by token holders, ranked according to the number of votes.",
                    "Standby witnesses: ranked according to the number of votes and weighted according to the number of votes. Take turns to work alongside the top witnesses.",
                    "Miner witnesses: generated according to the ranking of collateral and weighted according to the collateral amounts. Take turns to work."
                ]
            },
            {
                title:"Witness Qualification (collateral)",
                desc:[
                    "Any account with collateral over a certain amount of YOYO can become a witness. Current minimum value for collateral: 10,000 YOYO.",
                    "Witnesses are free to adjust the amount of collateral at any time.",
                    "The refunding of collateral deposits will be delayed for a certain period of time when the collateral amount is decreased or the collateral is cancelled. Current value: 1 day.",
                    "When there are continuous decreases in collateral, the amount will be accumulated and refunded in one lump sum. The time of refund will be delayed on the basis of the time of the last decrease.",
                    "For collateral increases, if there is a collateral deposit to be returned to the current account, that refund will be deducted first, and then the remaining amount will be deducted from the balance of the account."
                ]
            },
            {
                title:"Rewards of Witnesses",
                desc:[
                    "Witnesses will receive corresponding rewards for each block produced with NO vesting period.",
                    "Witnesses can withdraw “available” rewards into their balance at any time.",
                    "The amount of rewards accrued will depend on the type of witness."
                ]
            },
            {
                title:"Witness Election",
                desc:[
                    "Top witnesses and standby witnesses are determined according to rankings based on their number of votes. For voting regulation, please refer to [vote] (vote.md).",
                    "Miners are determined according to rankings based on collateral. For regulation on collateral ranking, please refer to [collateral] (collateral.md)"
                ]
            },
        ],
        authorizedRegistrars_info:[
            {
                title:"Authorized Registrars",
                desc:[
                    "Authorized registrars are appointed by the committee and have the authority to register accounts."
                ]
            },
            {
                title:"Rights of Authorized Registrars",
                desc:[
                    "Submitting applications for account registration to the chain through the faucet",
                    "Giving/taking back the right to post",
                    "Approving/taking back account names (nicknames)",
                    "More detailed rules and regulations on the rights of authorized registrars are to be developed"
                ]
            },
            {
                title:"Obligations of Authorized Registrars",
                desc:[
                    "Reviewing users’ applications for name changes"
                ]
            },
            {
                title:"Change of Authorized Registrar",
                desc:[
                    "When authorization of a certain registrar is canceled by the committee, all accounts under that registrar will be taken over, and relevant rights and obligations will also be transferred."
                ]
            },
        ],
        vote_info:[
            {
                title:"Voting",
                desc:[
                    "YOYOW uses the DPOS consensus algorithm. All token holders are able to choose witnesses and the committee through the voting system, allowing them to make decisions about the YOYOW system."
                ]
            },
            {
                title:"Voting Qualification",
                desc:[
                    "Voting qualification is assigned to those holders owning an amount ‘N’ of tokens. If the amount of tokens owned by a holder is lower than N, the holder will automatically be disqualified from voting. The current N value = 10,000, which can be modified by the committee.",
                    "Accounts included in the committee’s blacklist are disqualified from voting."
                ]
            },
            {
                title:"Intention to Vote",
                desc:[
                    "Users qualified for voting will activate their intention to vote when they vote for the first time. The validity period is T, which is initially set at 90 days.",
                    "If there is any new voting action within the validity period, it will be extended by T, which means, the expiry date will be changed to: the date of the updated voting action + T.",
                    "If there is no new voting action within the validity period, it is assumed that there is no more voting intention.",
                    "If users are disqualified from voting, or have no more voting intention, their votes will become void."
                ]
            },
            {
                title:"Voting Method",
                desc:[
                    "Committee elections: one vote for one candidate—each account can only support one candidate at one time, and the voter can change the vote at any time",
                    "Witness elections: one vote for numerous candidates—to strengthen consensus, each account can vote for numerous witnesses."
                ]
            },
            {
                title:"Vote Counting",
                desc:[
                    "To enhance the fairness of voting, vote counting also takes into consideration the voters’ number of tokens held, average token volume, time held and other factors.",
                    "The number of valid votes is equal to average balance over 60 days, or the current balance of the account (whichever is smaller), which means: number of valid votes = min (average balance within 60 days, current balance)",
                    "The number of votes for a candidate is equal to the total number of valid votes from supporters.",
                    "As it takes a lot of effort to count based on the age of the tokens in all accounts, which are updated in real-time, a delayed updating mode is used for vote counting, which means there might be a few deviations from counting based on real-time statistics."
                ]
            },
            {
                title:"Voting Proxies",
                desc:[
                    "A proxy can be designated for voting activities. For example: when Account A designates Account B as voting proxy, the voter of Account B will receive the valid vote(s) from both A and B. In this case, A is the client and B is the proxy.",
                    "Multi-layered proxies are allowed. For example: Account A designates Account B as its voting proxy, and Account B designates Account C as its voting proxy. However, there are restrictions on the total number of proxy layers.",
                    "Whenever there is an action of proxy voting, the validity period of the client’s intention to vote will be updated.",
                    "When the proxy has no intention to vote or no qualification to vote, the proxy relationship will be automatically terminated, and the client’s voting status will be changed to “with no vote for anyone” while the validity period of the client’s intention to vote remains the same.",
                    "When a proxy reactivates their intention to vote, the proxy relationship is not recovered."
                ]
            },
        ],
        collateral_info:[
            {
                title:"Collateral",
                desc:[
                    "The quota of miner witnesses for each issue shall be selected according to the collateral rate of each witness."
                ]
            },
            {
                title:"Rules for Collateral Ranking",
                desc:[
                    "The basic idea is to rank according to the arrangement of valid collateral of each account. For example, if A, B and C all deposit collateral, and A has six tokens of valid collateral, B has three tokens of valid collateral, and C has one token of valid collateral, then, for the following 100 blocks, it should be arranged that A produces 60 blocks, B produces 30 blocks and C produces 10 blocks.",
                    'The valid collateral will be the average collateral over seven days, or the current collateral (whichever is smaller). That is to say, when the collateral is increased, the valid collateral will increase gradually, and when the collateral decreases or is canceled, the valid collateral will immediately decrease.'
                ]
            },
        ],
        gateway_info:[
            {
                title:"ERC20 Gateway",
                desc:[
                    "The action of transferring YOYOW tokens in ether wallet to the YOYOW main chain is enabled for the moment. You can have the YOYOW tokens transferred from the ether wallet to the YOYOW main chain with this function."
                ]
            },
            {
                title:"Actions",
                desc:[
                    'Click “gateway”; if you have no binding ETH account, please click “generate address” for a unique ETH address.',
                    "Transfer your YOYOW tokens in the ether wallet to this address, and the system will automatically transfer an equivalent number of YOYO to your corresponding YOYOW account.",
                    'You can check account entries under “recent activities” or “assets”.'
                ]
            },
        ],
        extraFunctions_info:[
            {
                title:"Platform",
                desc:[
                    "You can sign in to multiple content platforms with the same YOYOW account directly if you have. Otherwise you should create YOYOW account and permit platforms to access your YOYOW tipping account."
                ]
            },
            {
                title:"Information sales",
                desc:[
                    "Users can use the \"information sales\" to sell and purchase information, and realize the information sales function of the blockchain. Currently, only YOYO is accepted."
                ]
            },
            {
                title:"Token issuance",
                desc:[
                    "You can realize your own issuance and management of the Token, you only need to pay a part of the fees. The fees are charged according to the length of the Token name. The shorter the length, the higher the cost, and the longer the length, the lower the cost."
                ]
            },
            {
                title:"Contact us",
                desc:[
                    "If you have any other questions, you can consult",
                    "YOYOW customer service WeChat: <a>yoyow99</a>",
                    "YOYOW official website: <a>https://www.yoyow.org</a>",
                    "YOYOW Email: <a>help@yoyow.org</a>",
                ]
            },
        ],

        service_protocol_name:"《YOYOW Service Agreement》",
        version_log:"Version log",
    }
}


// WEBPACK FOOTER //
// ./src/assets/common/en.js